export const PACKAGES = "packages";

export const PackageTypes = {
    FEATURED: "FEATURED",
    CUSTOM: "CUSTOM",
}

export const WineTypes = {
    FEATURED: "FEATURED",
    CUSTOM: "CUSTOM",
}